/*jshint esversion: 9 */

//TODO: Implement routes to the proper components
import React, { Component } from 'react';
import { doLog, deepCopy } from '../../../shared/utility';

import NavigationButtonItem from './NavigationButtonItem/NavigationButtonItem';

import classes from './NavigationButtonItems.css';

class navigationButtonItems extends Component {
    state = {
        appOptions: {
             ManageDB: {
                id: 'ManageDB',
                label: 'Configure',
                route: '/managedb',
                icon: null
            },
            Reports: {
                id: 'Reports',
                label: 'Reports',
                route: '/reports',
                icon: null
            },
            Review: {
                id: 'Review',
                label: 'Review',
                route: '/review',
                icon: null
            },
        }
    };

    render() {
        const usePermissions = true;
        const modulePermissions = deepCopy(this.props.modulePermissions);
        if (doLog()) console.log('NavigationButtonItems.render this.props.modulePermissions:', modulePermissions);

        let groupOptionIDs = [];
        
        if (usePermissions) {
            if (modulePermissions.allowManageDB)
                 groupOptionIDs.push('ManageDB');
            if (modulePermissions.allowReports)
                groupOptionIDs.push('Reports');
            if (modulePermissions.allowReview)
                groupOptionIDs.push('Review');
            // if (doLog()) console.log('NavigationButtonItems.render groupOptionIDs:', groupOptionIDs);
        }

        const optionsArray = [];
        for (let key in this.state.appOptions) {
            optionsArray.push({
                id: key,
                options: this.state.appOptions[key]
            });
        }

        const itemsPerLine = 3;
        let buttonList = groupOptionIDs.map(groupOption => {
            const options = optionsArray.find(element => {
                return element.id === groupOption;
            }).options;
            if (doLog()) console.log('NavigationButtonItems.render options:', options);
            // if (doLog()) console.log('NavigationButtonItems.render id:', options.id);
            // if (doLog()) console.log('NavigationButtonItems.render route:', options.route);
            // if (doLog()) console.log('NavigationButtonItems.render label:', options.label);

            return (
                <NavigationButtonItem link={options.route} key={options.id}>
                    <div>{options.label}</div>
                </NavigationButtonItem>
            );
        });

        if (doLog()) console.log('NavigationButtonItems.render buttonList:', buttonList);
        const buttonCount = buttonList.length;
        const maxRows = Math.ceil(buttonCount / itemsPerLine);
        // if (doLog()) console.log('NavigationButtonItems.render maxRows:', maxRows);
        let formattedButtonList = [maxRows];
        for (let i = 0; i < buttonCount; ) {
            const begin = i;
            let end = i + 3;
            if ( end > buttonCount )
                end = buttonCount;
            formattedButtonList[i] = (
                <div className={classes.Flex} key={begin}>
                    {buttonList.slice(begin,end)}
                </div>
            );
            i = i + 3;
            if ( i > buttonCount )
                i = buttonCount;
            // if (doLog()) console.log('NavigationButtonItems.render i:', i);
        }
        if (doLog()) console.log('NavigationButtonItems.render formattedButtonList:', formattedButtonList);

        return (
                <div className={classes.NavigationButtonItems}>
                    {formattedButtonList}
                </div>
        );
    }
};
        
export default navigationButtonItems;         